import { DotsFilledIcon } from '@approvalmax/ui';
import { Button, Dropdown, Menu } from '@approvalmax/ui/src/components';
import { Table } from '@approvalmax/ui/src/components';
import { FC, memo, useCallback } from 'react';
import { useToggle } from 'react-use';

import { messages } from './FieldMenuCell.messages';
import { FieldMenuCellProps } from './FieldMenuCell.types';

export const FieldMenuCell: FC<FieldMenuCellProps> = memo((props) => {
    const { item, onCustomFieldRemove, ...otherProps } = props;

    const [dropdownOpen, dropdownpOpenToogle] = useToggle(false);

    const onMenuItemClick = useCallback(() => {
        onCustomFieldRemove(item.id);
    }, [item.id, onCustomFieldRemove]);

    return (
        <Table.Cell {...otherProps} item={item}>
            <Dropdown
                open={dropdownOpen}
                onOpen={dropdownpOpenToogle}
                closeOnClickInnerButton
                activator={
                    <Button noPadding icon variant='text' color='blue100'>
                        <DotsFilledIcon size={24} />
                    </Button>
                }
                width='max-content'
            >
                <Menu>
                    <Menu.Item name={messages.remove} onClick={onMenuItemClick} />
                </Menu>
            </Dropdown>
        </Table.Cell>
    );
});

FieldMenuCell.displayName = 'FieldMenuCell';
